import { useQuery } from '@tanstack/react-query';

import { getPaymentDetails } from '../../api/payment-details.api';

export const PAYMENT_DETAILS_QUERY_KEY = ['payment-details'];
export const PAYMENT_DETAILS_SHORT_QUERY_KEY = ['payment-details-short'];
export const PAYMENT_DETAILS_STALE_TIME = 1 * 60 * 60 * 1000; // 1 hour - entries change rarely

/**
 * Full payment-details list for the Finance settings card.
 * No pagination needed - entry counts are small (soft-capped per org), same as seniorities.
 */
export const usePaymentDetails = () => {
  return useQuery({
    queryKey: PAYMENT_DETAILS_QUERY_KEY,
    queryFn: getPaymentDetails,
    staleTime: PAYMENT_DETAILS_STALE_TIME,
  });
};
